/**
 * Hybrid Loader Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import React from "react";
import type { TypeLoaderProps } from "./LoaderTypes";
import Container, { Spinner, Text } from "./styles"; // Styled-components version
import { LoaderTailwind } from "./LoaderTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";

const LoaderHybrid = React.forwardRef<HTMLDivElement, TypeLoaderProps>(
  (props, ref) => {
    const {
      size = "large",
      text = "",
      delay = true,
      color = "dark",
      qa,
      ...rest
    } = props;

    if (hasStyledProps(rest)) {
      return (
        <Container
          small={size === "small"}
          dark={color === "dark"}
          delay={delay}
          data-qa-loader=""
          ref={ref}
          {...qa}
          {...rest}
        >
          <Spinner small={size === "small"} aria-hidden="true" />
          <Text>{text || "Loading"}</Text>
        </Container>
      );
    }

    // Use Tailwind version (preferred - better performance)
    return <LoaderTailwind {...props} ref={ref} />;
  }
);

LoaderHybrid.displayName = "Loader";
export default LoaderHybrid;
